import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n    flex-basis: 30%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text, Icon } from '../../Atoms';
export var StyledText = styled(Text)(_templateObject(), function () {
  return "\n        display: flex;\n        align-items: center;\n        min-width: 0;\n    ";
});
export var StyledLeftText = styled(StyledText)(_templateObject2());
export var StyledRightText = styled(StyledText)(_templateObject3(), function (props) {
  return "\n        justify-content: flex-end;\n        flex-basis: 70%;\n\n        & > span {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n\n        & > *:nth-child(n+1) {\n            margin-left: ".concat(props.theme.components.typography.sideBySideMarginLeft, ";\n        }\n    ");
});
export var StyledSideBySideText = styled.div(_templateObject4(), function (props) {
  return "\n        position: relative;\n        display: flex;\n        justify-content: space-between;\n        width: ".concat(props.width, ";\n        align-items: center;\n        max-width: 100%;\n\n        ").concat(props.copy ? "\n                    cursor: pointer;\n\n                    ".concat(Icon.Styles.StyledIcon, " {\n                        cursor: pointer;\n                    }\n                ") : '', "\n    ");
});